export default __webpack_public_path__ + "static/media/insta.21f01d6c.svg";